import { render } from "./InviteUser.vue?vue&type=template&id=30faaf76&scoped=true"
import script from "./InviteUser.vue?vue&type=script&lang=js"
export * from "./InviteUser.vue?vue&type=script&lang=js"

import "./InviteUser.vue?vue&type=style&index=0&id=30faaf76&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30faaf76"]])

export default __exports__